import { render, staticRenderFns } from "./history.vue?vue&type=template&id=797dbc13&scoped=true&"
import script from "./history.vue?vue&type=script&lang=js&"
export * from "./history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797dbc13",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('797dbc13')) {
      api.createRecord('797dbc13', component.options)
    } else {
      api.reload('797dbc13', component.options)
    }
    module.hot.accept("./history.vue?vue&type=template&id=797dbc13&scoped=true&", function () {
      api.rerender('797dbc13', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw_requests/tabs/history.vue"
export default component.exports